import type { User } from '@casetrace/shared';
import { AdminCreateUserForm } from './admin-create-user-form';
import { AdminUserRow } from './admin-user-row';

interface AdminUsersListProps {
  users: readonly User[];
}

export function AdminUsersList({ users }: AdminUsersListProps) {
  return (
    <section className="rounded-lg border border-white/[0.07] bg-surface p-4">
      <div className="mb-4 flex items-center justify-between">
        <h2 className="text-sm font-semibold text-text-primary">Brukere</h2>
        <span className="text-xs text-text-tertiary">{users.length} totalt</span>
      </div>
      <div className="mb-5 rounded-md border border-white/[0.06] bg-white/[0.03] p-3">
        <AdminCreateUserForm />
      </div>
      <div className="space-y-2">
        {users.map((user) => (
          <AdminUserRow key={user.id} user={user} />
        ))}
      </div>
    </section>
  );
}
